var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-reward"},[_c('div',{staticClass:"author-reward-btn"},[_c('i',{staticClass:"icon i_shang"}),_vm._v("我要打赏")])])}]

export { render, staticRenderFns }